import { Component, Input } from '@angular/core';
import { Message } from '../../../interfaces/message';
declare var window:any;

@Component({
  selector: 'app-recent-message',
  templateUrl: './recent-message.component.html',
  styleUrls: ['./recent-message.component.scss']
})
export class RecentMessageComponent {
  @Input() message!: Message;

  openPopup(event: MouseEvent) {
    event.preventDefault();
    window.MessagePopup.openMessagePopup(this.message.nodeId, event.currentTarget!);
  }
}
